import { CustomeSearchState } from '@/types/models'
import { generateAlgoliaConfigurationFromSearchState } from '../../utils/search/generateAlgoliaConfigurationFromSearchState'
import { generateFacetFilters } from './generateFacetFilters'
import { isNonEmptyObject } from '@/utils/checks'
import parseIntOrDefault from '@/utils/parseIntOrDefault'

const normalizeSearchState = (
  searchState: CustomeSearchState = {}
): CustomeSearchState => {
  if (!isNonEmptyObject(searchState)) {
    return {
      configure: generateAlgoliaConfigurationFromSearchState()
    }
  }

  const parsedCustomLocationRadiusInMiles = parseIntOrDefault(
    searchState.customLocationRadiusInMiles
  )

  const customLocationRadiusInMilesObject = isNaN(
    parsedCustomLocationRadiusInMiles
  )
    ? {}
    : { customLocationRadiusInMiles: parsedCustomLocationRadiusInMiles }

  const searchStateWithFacetFilters = {
    ...searchState,
    ...customLocationRadiusInMilesObject,
    configure: {
      ...(searchState.configure || {}),
      facetFilters: generateFacetFilters({
        refinementList: searchState.refinementList || {}
      }),
      page: parseIntOrDefault(searchState.configure?.page, 0)
    }
  }

  const configure = generateAlgoliaConfigurationFromSearchState(
    searchStateWithFacetFilters
  )

  return {
    ...searchState,
    configure
  }
}

export default normalizeSearchState
